module.exports = __webpack_public_path__ + "img/logo08.24d2848.jpg";